<template>
  <div class="stat-tile">
    <p class="stat-tile-label">{{ label }}</p>
    <div class="stat-tile-figure">
      <span class="stat-tile-value">{{ displayValue }}</span>
      <span
        v-if="delta !== null && delta !== undefined"
        class="stat-tile-delta"
        :style="{ color: tone.color, background: tone.background }"
      >
        {{ deltaArrow }} {{ Math.abs(delta) }}{{ unit }}
      </span>
    </div>
    <apexchart
      v-if="spark && spark.length"
      type="area"
      height="38"
      :options="sparkChartOptions"
      :series="[{ name: label, data: spark }]"
    />
  </div>
</template>

<script>
import { sparkOptions, deltaTone, SERIES } from '@/services/chartTheme';

export default {
  name: 'StatTile',
  props: {
    label: { type: String, required: true },
    value: { default: null },
    unit: { type: String, default: '' },
    delta: { default: null },
    spark: { type: Array, default: () => [] },
    // For rates where DOWN is the good direction (discrepancy, unwitnessed),
    // so the delta colour reads as improvement, not raw sign.
    downIsGood: { type: Boolean, default: false },
  },
  computed: {
    displayValue() {
      // null is "no data", and must not render as 0 - a governance figure
      // claiming 0% from an empty denominator would be a lie.
      if (this.value === null || this.value === undefined) return '—';
      return `${this.value}${this.unit}`;
    },
    deltaArrow() {
      // Computed rather than inline: a bare `<` inside a template mustache is
      // parsed as a tag opening and fails the SFC compile.
      if (!this.delta) return '—';
      return this.delta > 0 ? '▲' : '▼';
    },
    tone() {
      return deltaTone(this.delta, this.downIsGood);
    },
    sparkChartOptions() {
      return sparkOptions(SERIES[0], this.spark.length - 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.stat-tile {
  background: white;
  border: 1px solid rgba(11, 11, 11, 0.07);
  border-radius: 10px;
  padding: 12px 16px 6px 16px;
  text-align: left;
  box-shadow: 0 1px 2px rgba(11, 11, 11, 0.04);
  transition: box-shadow 0.2s, transform 0.2s;

  &:hover {
    box-shadow: 0 4px 14px rgba(11, 11, 11, 0.08);
    transform: translateY(-1px);
  }
}
.stat-tile-label {
  font-size: 12px;
  color: #7a7f85;
  margin: 0 0 4px 0;
}
.stat-tile-figure {
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.stat-tile-value {
  font-size: 27px;
  font-weight: 600;
  letter-spacing: -0.5px;
  color: #333333;
}
.stat-tile-delta {
  flex: 0 0 auto;
  padding: 2px 7px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}
</style>
